export default __webpack_public_path__ + "static/healthcare-tran-ff654d6413ef21160a0b3f15cb1a2ba4.png";